const constants = {
    RS:'Rs',
    TAX_MSG:'Price inclusive of all taxes',
    SIZE_MSG:'Select a size'
}
export default constants;